import Vue from 'vue'

import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Bootstrap 4
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue.js'

Vue.use(BootstrapVue)

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon.vue'

Vue.component('icon', Icon)
import './assets/css/style.css'
import routes from './routes'

const router = new VueRouter({routes});
import MainComponent from './layouts/Main.vue'

import VueImg from 'v-img';
Vue.use(VueImg);

new Vue({
    router,
    el: '#app',
    render(h) {
        return h(MainComponent)
    }
})




// WEBPACK FOOTER //
// ./resources/assets/src/main.js